import { useQuery } from "@tanstack/react-query";
import { getProjectRecommendations } from "@/app/actions/project/action";
import { ProjectCallsRecommendationKind } from "@/app/types/call/CallAnalysis";
import { QueryKey } from "@/app/vars/QueryKeys";

export function useFetchProjectRecommendations(
  projectId?: number,
  offerId?: number,
  kind?: ProjectCallsRecommendationKind,
) {
  return useQuery({
    queryKey: [QueryKey.PROJECT_RECOMMENDATIONS, projectId, offerId ?? null, kind],
    queryFn: () => {
      if (!projectId) return null;
      return getProjectRecommendations(projectId, offerId, kind);
    },
    enabled: !!projectId,
    staleTime: Infinity,
  });
}
